export const FIXED_PRICE_PLAN = 'FIXED_PRICE';
export const ON_DEMAND_PLAN = 'ON_DEMAND';